<template>
  <div>
    <div class="accordion">
      <div class="or-container">
        <div class="box" :class="eleindex ==0?'eleactive':''" @mouseenter="enter(0)" @mouseleave="out">
          <img v-if="$i18n.locale == 'zh'" src="../assets/accordion/01.png">
          <img v-else src="../assets/accordion/01_en.png">
        </div>
        <div class="box" :class="eleindex ==1?'eleactive':''" @mouseenter="enter(1)" @mouseleave="out">
          <img v-if="$i18n.locale == 'zh'" src="../assets/accordion/02.png">
          <img v-else src="../assets/accordion/02_en.png">
        </div>
        <div class="box" :class="eleindex ==2?'eleactive':''" @mouseenter="enter(2)" @mouseleave="out">
          <img v-if="$i18n.locale == 'zh'" src="../assets/accordion/03.png">
          <img v-else src="../assets/accordion/03_en.png">
        </div>
        <div class="box" :class="eleindex ==3?'eleactive':''" @mouseenter="enter(3)" @mouseleave="out">
          <img v-if="$i18n.locale == 'zh'" src="../assets/accordion/04.png">
          <img v-else src="../assets/accordion/04_en.png">
        </div>
      </div>
    </div>
  </div>
  <!--手风琴组件-->

</template>

<script>
export default {
  name: "Accordion",
  data () {
    return {
      eleindex: 0,
      timer: null
    }
  },
  methods:{
    enter (index) {
      console.log(index)
      this.eleindex = index
      // if (this.eleindex === i) {
      //   this.eleindex = -1
      // } else {
      //   this.eleindex = i
      // }
      clearInterval(this.timer)
    },
    out () {
      this.goSwiper()
    },
    goSwiper() {
      this.timer = setInterval(() => {
        if (this.eleindex < 3) {
          this.eleindex = this.eleindex + 1
        } else {
          this.eleindex = 0
        }
      }, 2000)
    }
  },
  mounted() {
    this.goSwiper()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>
<style lang="scss" scoped>
.or-container {
  display: flex;
  width: 100%;
  height: 769px;
}

.box {
  flex: 1;
  overflow: hidden;
  transition: .5s;
  position: relative;
  width: 100%;
  background: #000;
}

.box > img {
  width: 100%;
  height: 100%;
  //-o-object-fit: cover;
  object-fit: cover;
  object-fit: none;
  transition: .5s;
}

.eleactive {
  flex: 1 1 50%;
}

.eleactive > img {
  width: 100%;
  height: 100%;
}
</style>
